module.exports = __webpack_public_path__ + "static/premainamp-f7a57ee6ce3e2c95eabf1f44921920b8.jpg";